import meiliSearchApiClient from 'src/api/clients/meilisearch';
import tenantApi from 'src/api/clients/tenant';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { MeiliSearchResponse } from 'src/types/responses/meilisearch';
import { calculatePaginationOffset } from 'src/utils/calculate-pagination-offset';
import { CreateBookingPayload } from '../types/payload/create-booking.payload';
import { Booking } from '../types/response/booking.response';

export const fetchBookings = async (
  tenantToken: string,
  searchState: SearchState,
  page: number,
  perPage: number,
) => {
  const { data } = await meiliSearchApiClient.post<
    MeiliSearchResponse<Booking>
  >(`/indexes/Booking-${tenantToken}/search`, {
    ...searchState,
    limit: perPage,
    offset: calculatePaginationOffset(page, perPage),
  });

  return data;
};

export const createBooking = async (
  payload: CreateBookingPayload,
): Promise<void> => {
  await tenantApi.post<void>('/bookings', payload);
};

export const confirmBookingPresence = async (
  bookingToken: string,
  spaceToken: string,
): Promise<void> => {
  await tenantApi.post<void>(
    `/bookings/${bookingToken}/spaces/${spaceToken}/confirm-presence`,
  );
};
export const finishBooking = async (bookingToken: string): Promise<void> => {
  await tenantApi.post<void>(`/bookings/${bookingToken}/finish`);
};

export const cancelBooking = async (bookingToken: string): Promise<void> => {
  await tenantApi.post<void>(`/bookings/${bookingToken}/cancel`);
};

export const exportBookingsAsXls = async (
  from: Date,
  to: Date,
): Promise<{ fileName: string; content: Blob }> => {
  //TODO: Add api integration
  console.log('exportBookingsAsXls', from, to);

  const data = new Blob();

  const fileName = 'bookings.xls';

  return { fileName, content: data };
};
